<template>
  <div>
    <FileInput accept="image" @change="onupload"><slot /></FileInput>
    <img v-if="logo" :src="logo" />
  </div>
</template>

<script>
import FileInput from "./FileInput.vue";
export default {
  components: { FileInput },
  data() {
    return {
      logo: null
    };
  },

  methods: {
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    async onupload(files) {
      let file = files[0];
      if (file) {
        let base = await this.toBase64(file);
        this.$emit("imageSelected", base);
      }
    }
  }
};
</script>

<style scoped>
img {
  max-width: 200px;
  display: block;
}
</style>
